export const MAX_CARDS_TO_DISPLAY_BEFORE_EXPANDED = 4;
